module.exports = __webpack_public_path__ + "static/media/Artboard5.4676931c.png";